// eslint-disable-next-line no-use-before-define
import React, { MouseEvent, FunctionComponent } from "react";
import { ButtonFieldProps } from "../../interfaces/components/button.interface";

const Button: FunctionComponent<ButtonFieldProps> = ({
  disabled,
  title,
  outline = false,
  primary = true,
  secondary = false,
  large = false,
  type = "button",
  onClickHandler,
  onKeyDownHandler,
  isLoading = false,
  children,
}: ButtonFieldProps) => {
  const outlineClasses: string = outline ? "hq-button--outline " : "";

  const primaryClasses: string =
    primary && !outline && !disabled ? "hq-button--primary " : "";

  const secondaryClasses: string =
    secondary && !outline ? "hq-button--secondary " : "";

  const largeClasses: string = large ? "hq-button--large " : "";

  const disabledClasses: string = disabled ? "hq-button--disabled" : "";

  const clickHandler = (event: MouseEvent<HTMLButtonElement>): void => {
    if (onClickHandler) {
      onClickHandler(event);
    }
  };
  const keyHandler = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "Enter") {
      if (onKeyDownHandler) {
        onKeyDownHandler(event);
      }
    }
  };
  return (
    <div className="hq-button">
      <button
        data-test="button-wrapper"
        disabled={disabled}
        className={`hq-button--button  ${disabledClasses} ${outlineClasses} ${primaryClasses} ${secondaryClasses} ${largeClasses}`}
        type={type}
        onClick={clickHandler}
        onKeyDown={keyHandler}
      >
        {isLoading ? <i className="fa fa-refresh fa-spin" /> : title}
      </button>
    </div>
  );
};
export default Button;
